import React from 'react';

const FormulaIcon = () => (
  <svg className="mx-2" width="100%" height="100%" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.85355 14.8536L14.8536 1.85355C15.0488 1.65829 15.0488 1.34171 14.8536 1.14645C14.6583 0.951184 14.3417 0.951184 14.1464 1.14645L1.14645 14.1464C0.951184 14.3417 0.951184 14.6583 1.14645 14.8536C1.34171 15.0488 1.65829 15.0488 1.85355 14.8536Z" fill="black"/>
    <path d="M4 1C4.27614 1 4.5 1.22386 4.5 1.5V3.5H6.5C6.77614 3.5 7 3.72386 7 4C7 4.27614 6.77614 4.5 6.5 4.5H4.5V6.5C4.5 6.77614 4.27614 7 4 7C3.72386 7 3.5 6.77614 3.5 6.5V4.5H1.5C1.22386 4.5 1 4.27614 1 4C1 3.72386 1.22386 3.5 1.5 3.5H3.5V1.5C3.5 1.22386 3.72386 1 4 1Z" fill="black"/>
    <path d="M9 12C9 11.7239 9.22386 11.5 9.5 11.5H14.5C14.7761 11.5 15 11.7239 15 12C15 12.2761 14.7761 12.5 14.5 12.5H9.5C9.22386 12.5 9 12.2761 9 12Z" fill="black"/>
  </svg>
);

export default FormulaIcon;